<template>
	<div class="add_or_edit_topic">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">作品提交</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<el-form :model="addTopicForm" :rules="addTopicFormRules" ref="addTopicFormRef" label-width="100px" class="demo-addTopicForm">
											<el-form-item label="作品类型" prop="typeWork">先进个人</el-form-item>
											<el-form-item label="作品名称" prop="title"><el-input v-model="addTopicForm.title"></el-input></el-form-item>
											<el-form-item label="第一作者" prop="author">
												<el-input style="width: 100px;" maxlength="4" v-if="roleId" v-model="addTopicForm.author"></el-input>
												<div v-else>{{ addTopicForm.author }}</div>
											</el-form-item>
											<el-form-item label="主要参与者" prop="author" v-if="projectInfo.memberNumberLimit">
												<el-input
													v-for="(item, index) in mainPerson"
													:key="index"
													maxlength="4"
													style="width: 100px;margin-right: 20px;"
													v-model="item.name"
												></el-input>
												<span style="color: red;">每个输入框只允许填写一名参与者</span>
											</el-form-item>
											<el-form-item label="所属单位" prop="unit"><el-input v-model="addTopicForm.unit"></el-input></el-form-item>
											<el-form-item label="联系电话" prop="phone"><el-input v-model="addTopicForm.phone"></el-input></el-form-item>
											<el-form-item label="所属学段" prop="learningSection" v-if="typeArr.includes(0)">
												<el-radio-group v-model="addTopicForm.learningSection">
													<el-radio v-for="(item, index) in learingTypeOptions" :key="index" :label="item.value">{{ item.label }}</el-radio>
												</el-radio-group>
											</el-form-item>
											<el-form-item label="所属学科" prop="disciplineId" v-if="typeArr.includes(1)">
												<el-select v-model="addTopicForm.disciplineId" placeholder="请选择" clearable>
													<el-option v-for="item in disciplineOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item label="关键词" prop="keyWord" v-if="typeArr.includes(2)">
												<el-input style="width: 100%;" v-model="addTopicForm.keyWord" class="input-wd"></el-input>
											</el-form-item>
											<el-form-item label="简介/摘要" prop="introduction" v-if="typeArr.includes(3)">
												<el-input v-model="addTopicForm.introduction" type="textarea" row="4"></el-input>
											</el-form-item>
											<el-form-item><div style="position: relative;margin-left: -70px;">说明：上传附件大小不得超过300Mb</div></el-form-item>
											<!-- 文件 -->
											<el-form-item
												style="text-align: left;"
												:class="item.isTrue ? 'item-cell' : ' '"
												:label="item.value"
												v-for="(item, index) in projectInfo.eduAnnexNames1"
												:key="index"
											>
												<UploadFile @delBtn="delBtnUpload" @file-event="changeDataUpload(item, $event, index)" :value="item" />
											</el-form-item>
											<el-form-item label="匿名评审文档" prop="review" v-if="typeArr.includes(4)">
												<UploadFile @delBtn="delBtnUpload2" @file-event="changeData('review', $event)" :value="review" />
											</el-form-item>
											<el-form-item>
												<div style="text-align: center;">
													<el-button type="primary" @click="createTopic" :loading="isSub">保存</el-button>
													<el-button type="primary" @click="goBack" class="back">返回</el-button>
												</div>
											</el-form-item>
										</el-form>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getPlatformInformationData } from '@/api/after/systemManagement.js';
import { addReview, getApiReview, updateReview, getReviewInfo } from '@/api/after/newInterface.js';
import UploadFile from '@/components/UploadFile2.vue';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import { number } from 'echarts/lib/export';
export default {
	components: {
		Breadcrumb,
		UploadFile
	},
	data() {
		return {
			addTopicForm: {
				projectId: null,
				typeWork: null, //作品类型
				title: null, //名称
				author: null, //作者
				unit: null, //所属单位
				phone: null, //联系电话
				learningSection: null, //所属学段
				disciplineId: null, //所属学科
				keyWord: null, //关键词
				introduction: null, //简介
				device: null,
				review: null,
				devise: null,
				teachingCourseware: null,
				record: null,
				microcourse: null,
				list: []
			},
			projectInfo: {
				eduAnnexNames1: []
			},
			device: {
				id: '',
				name: ''
			}, //作品主件
			review: {
				id: '',
				name: ''
			}, //评审文档
			devise: {
				id: '',
				name: ''
			}, //教学设计
			teachingCourseware: {
				id: '',
				name: ''
			}, //教学课件
			record: {
				id: '',
				name: ''
			}, //课堂实录
			microcourse: {
				id: '',
				name: ''
			}, //微课
			addTopicFormRules: {
				title: [{ required: true, message: '请输入名称', trigger: 'change' }, { min: 1, max: 60, message: '限60字', trigger: 'blur' }],
				unit: [{ required: true, message: '请输入所属单位', trigger: 'change' }],
				phone: [{ required: true, message: '请输入联系电话', trigger: 'change' }],
				learningSection: [{ required: true, message: '请选择所属学段', trigger: 'change' }],
				disciplineId: [{ required: true, message: '请选择所属学科', trigger: 'change' }],
				keyWord: [{ required: true, message: '请输入关键词', trigger: 'change' }],
				introduction: [{ required: true, message: '请输入作品简介', trigger: 'change' }],
				name: [{ required: true, message: '请上传作品主件', trigger: 'change' }],
				// device: [{ required: true, message: '请上传作品主件', trigger: 'change' }],
				review: [{ required: true, message: '请上传评审文档', trigger: 'change' }]
				// devise: [{ required: true, message: '请上传教学设计', trigger: 'change' }],
				// teachingCourseware: [{ required: true, message: '请上传教学课件', trigger: 'change' }]
			},
			disciplineOptions: [], //学科
			// 学段
			learingTypeOptions: [
				{
					value: '0',
					label: '幼儿园'
				},
				{
					value: '1',
					label: '小学'
				},
				{
					value: '2',
					label: '初中'
				},
				{
					value: '3',
					label: '高中'
				},
				{
					value: '4',
					label: '高/中职'
				},
				{
					value: '5',
					label: '其他'
				}
			],
			roleId: null,
			typeArr: [],
			uploadArr: [],
			mainPerson: [],
			isSub: false
		};
	},
	mounted() {
		// 第一作者
		if (!this.roleId) {
			this.addTopicForm.author = JSON.parse(sessionStorage.getItem('userInfo')).realName;
		}
		this.getDiscipline();
		this.addTopicForm.projectId = sessionStorage.getItem('workId');
		this.getCellInfo(this.addTopicForm.projectId);

		this.roleId = JSON.parse(sessionStorage.getItem('userInfo')).roleId;
		this.addTopicForm.unit = JSON.parse(sessionStorage.getItem('userInfo')).unitName;
	},
	methods: {
		getCellInfo(id) {
			getReviewInfo(id).then(res => {
				if (res.code == 200) {
					this.projectInfo = res.data;
					if (this.projectInfo.memberNumberLimit) {
						for (let i = 0; i < this.projectInfo.memberNumberLimit; i++) {
							this.$set(this.mainPerson, i, {
								name: ''
							});
						}
					}
					if (this.projectInfo.eduAnnexNames1) {
						this.projectInfo.eduAnnexNames1.forEach((item, index) => {
							this.$set(item, 'id', '');
							this.$set(item, 'name', '');
							this.$set(item, 'title', `title${index}`);
							if (item.name1) {
								this.$set(item, 'name', item.name1);
							}
						});
					}
					this.typeArr = res.data.ontherId.split(',').map(Number);
					if (this.$route.query.id) {
						this.getInfo(this.$route.query.id);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		getInfo(id) {
			let that = this;
			getApiReview(id).then(res => {
				if (res.code == 200) {
					this.addTopicForm = res.data;
					this.review = res.data.review1;
					this.device = res.data.device1;
					this.projectInfo.eduAnnexNames1 = res.data.list;
					if (this.projectInfo.eduAnnexNames1.length > 0) {
						this.projectInfo.eduAnnexNames1.forEach(item => {
							this.$set(item, 'name', item.name1);
							this.$set(item, 'isTrue', item.isTrue);
						});
					}
					if (res.data.record) {
						const code = res.data.record.split(',');
						this.mainPerson = code.map(item => {
							return {
								name: item
							};
						});
						// for (let i = 0; i < code.length; i++) {
						// 	this.$set(this.mainPerson[i], 'name', code[i]);
						// }
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		delBtnUpload2(e) {
			e.name = '';
			e.id = '';
			this.addTopicForm.review = '';
			this.review.id = '';
			this.review.name = '';
		},
		delBtnUpload(e) {
			let fileId = e.id;
			let findIndex = this.uploadArr.findIndex(item => item.id == fileId);
			if (findIndex !== -1) {
				this.uploadArr.splice(findIndex, 1);
			}
			e.id = '';
			e.name1 = '';
			e.name = '';
		},
		changeDataUpload(item, data, index) {
			if (data.id) {
				this.uploadArr.push({
					name: item.value,
					id: data.id
				});
			} else {
				this.uploadArr.splice(index, 1);
			}
		},
		changeData(name, data) {
			if (name == 'device') {
				this.addTopicForm.device = data.id;
			}
			if (name == 'review') {
				this.addTopicForm.review = data.id;
			}
			if (name == 'devise') {
				this.addTopicForm.devise = data.id;
			}
			if (name == 'teachingCourseware') {
				this.addTopicForm.teachingCourseware = data.id;
			}
			if (name == 'record') {
				this.addTopicForm.record = data.id;
			}
			if (name == 'microcourse') {
				this.addTopicForm.microcourse = data.id;
			}
		},
		// 获取学科
		async getDiscipline() {
			const res = await getPlatformInformationData(13);
			if (res.code == 200) {
				this.disciplineOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		createTopic() {
			this.$refs.addTopicFormRef.validate(async valid => {
				if (valid) {
					this.isSub = true;
					if (this.projectInfo.eduAnnexNames1.length > 0) {
						if (this.uploadArr.length > 0) {
							this.projectInfo.eduAnnexNames1.forEach(item1 => {
								this.uploadArr.forEach(item2 => {
									if (item1.value == item2.name) {
										item1.name = item2.name;
										item1.id = item2.id;
										if (this.$route.query.id) {
											this.$set(item1, 'name', item1.name1);
										} else {
											this.$set(item1, 'name', item1.value);
										}
									}
								});
							});
						}
					}
					let isTrue = false;
					//检测必传文件是否上传
					this.projectInfo.eduAnnexNames1.map(item => {
						if (item.isTrue && !item.id) {
							this.$message.error(`请上传${item.value}的文件`);
							this.isSub = false;
							return (isTrue = true);
						}
					});
					if (isTrue) {
						return;
					}
					//文件上传
					this.addTopicForm.list = this.projectInfo.eduAnnexNames1.map(item3 => {
						return {
							name: item3.value,
							id: item3.id,
							isTrue: item3.isTrue
						};
					});
					if (this.mainPerson.length > 0) {
						let arr = this.mainPerson.filter(item => item.name);
						this.addTopicForm.record = arr ? arr.map(item => item.name).join(',') : '';
					}
					if (this.$route.query.id) {
						updateReview(this.addTopicForm).then(res => {
							if (res.code == 200) {
								this.$message.success('操作成功');
								this.isSub = false;
								this.goBack();
							} else {
								this.isSub = false;
								this.$message.error(res.data);
							}
						});
					} else {
						addReview(this.addTopicForm).then(res => {
							if (res.code == 200) {
								this.$message.success('操作成功');
								this.isSub = false;
								this.goBack();
							} else {
								this.isSub = false;
								this.$message.error(res.data);
							}
						});
					}
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		goBack() {
			this.$router.go(-1);
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-form-item__label {
	min-width: max-content;
}

.item-cell {
	position: relative;
	// margin-left: 33px;
}

.item-cell::before {
	content: '*';
	display: inline-block;
	position: absolute;
	// left: 10px;
	top: 10px;
	color: red;
}

.input-wd {
	margin-right: 10px;
}

.author {
	background-color: #fff;
	background-image: none;
	border-radius: 4px;
	border: 1px solid #dcdfe6;
	box-sizing: border-box;
	color: #606266;
	height: 40px;
	line-height: 40px;
	outline: 0;
	padding: 0 15px;
	transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
	width: 100%;
}

.back {
	margin-left: 60px;
	background-color: #dee1e6;
	outline: none;
	border: none;
}

// .warn-icon {
// 	position: absolute;
// 	left: 0;
// 	// left: -30px;
// 	color: red;
// }
</style>
